/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-30 10:57:30
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 11:09:06
 */
import menu from "./zh-CN/menu";
import nav from "@/language/locales/zh-CN/nav";
import dashboard from "@/language/locales/zh-CN/dashboard";
import account from "@/language/locales/zh-CN/account";
import automatedRules from "@/language/locales/zh-CN/automatedRules";

import teamSettings from "@/language/locales/zh-CN/teamSettings";
import subscription from "@/language/locales/zh-CN/subscription";
import billing from "@/language/locales/zh-CN/billing";
import tips from "@/language/locales/zh-CN/tips";
import accountSettings from "@/language/locales/zh-CN/accountSettings";
import actionButton from "./zh-CN/actionButton";
import message from "./zh-CN/message";
import condition from "./zh-CN/condition";
import optimizationEvent from "./zh-CN/optimizationEvent";
import language from "./zh-CN/language";
import common from "./zh-CN/common";

export default {
	...nav,
	...menu,
	...dashboard,
	...account,
	...automatedRules,

	...teamSettings,
	...subscription,
	...billing,
	...tips,
	...accountSettings,
	...actionButton,
	...message,
	...condition,
	...optimizationEvent,
	...language,
	...common
};
